'use client';
import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { FeaturedArticleCard } from './FeaturedArticleCard';
import { useBlogContext } from '@/context/BlogContext';
import styles from '../blogpage.module.css';

const FeaturedArticlesSlider = () => {
  const { featuredBlogs } = useBlogContext();
  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    containScroll: 'trimSnaps',
    watchSlides: true,
  });

  return (
    <div
      className={`${styles.breakout} flex flex-col justify-center items-center gap-8 md:gap-16 w-full`}
    >
      <div className="flex justify-center items-center gap-2 md:gap-10 w-full">
        <h2 className="font-inter-tight text-[#89D7DF] text-[18px] md:text-[22px] uppercase shrink-0">
          Featured Articles
        </h2>
        <span className="opacity-60 border-[#8AD6DE] border-t w-full h-[1px]"></span>
      </div>

      <div
        className={`relative w-full featured-cards`}
        style={{
          maskImage:
            'linear-gradient(to right, black 20% 80%, transparent 100%)',
        }}
      >
        <div ref={emblaRef} className="w-full overflow-hidden">
          <div className="flex -ml-[30px] pr-[30px]">
            {featuredBlogs?.map((blog) => (
              <div
                key={blog.id}
                className="relative min-w-0 flex-[0_0_330px] md:flex-[0_0_400px] h-[519px] pl-[30px]"
              >
                <FeaturedArticleCard blog={blog} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedArticlesSlider;
